import React, { useEffect, useState }                                                       from 'react';
import { Button, Spinner }                                                                  from 'react-bootstrap';
import { useDispatch, useSelector }                                                         from 'react-redux';

import UserSearch                                                                           from './UserSearch';
import AuthoritiesService                                                                   from '../../../services/AuthoritiesService';

import { MSG_DELETE, MSG_NOT_REVERT_OPERATION }                                             from '../../../constants/messages';
import { ACTION_DELETE, ACTION_EDIT, ACTION_ENABLE, ACTION_RESET_PASS }                     from '../../extras/actionTypes';
import { ICON_NEXT_ALT, ICON_PREV_ALT }                                                     from '../../extras/icons';
import { ConfirmDeleteMessage, ConfirmMessage }                                             from '../../extras/toastMessages';

import TableList                                                                            from '../../layout/TableList';

import { listUsersAction, editUsersAction, deleteUsersAction, resetPasswordUsersAction }    from '../../../actions/usersActions';
import { enableUsersAction }                                                                from '../../../actions/usersActions';

import { PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR, USUARIOS_CREAR }                        from '../../../data/objects';




const UserList = props => {


    // ==========================================================================================
    // DECLARACIONES ----------------------------------------------------------------------------
    // ==========================================================================================

    // Constantes iniciales
    const initialPage = 0;
    const pageSize = 10;
    
    // Inicializo el state local
    const [ page, setPage ] = useState(initialPage);
    const [ search, setSearch ] = useState('');
    
    // Parámetros iniciales
    const params = {
        paging: `${page},${pageSize}`,
        sort: 'apellido:asc,nombre:asc',
        search
    }

    // Tomo los props
    const { handleOpen, handleClose } = props;

    // Inicializo el dispatch
    const dispatch = useDispatch(); 



    // ==========================================================================================
    // CARGA DE VALORES -------------------------------------------------------------------------
    // ==========================================================================================  
    
    //Traigo el store de persona tipos
    const actualPage = useSelector(state => state.users.actualPage);
    const authorities = useSelector(state => state.auth.authorities);
    const isFirst = useSelector(state => state.users.isFirst);
    const isLast = useSelector(state => state.users.isLast);
    const total = useSelector(state => state.users.total);
    const totalPages = useSelector(state => state.users.totalPages);    
    const users = useSelector( state => state.users.users );
    const usersLoading = useSelector( state => state.users.loading );



    // ==========================================================================================
    // FUNCIONES --------------------------------------------------------------------------------
    // ==========================================================================================    
    
    // Manjo la eliminación
    const handleDelete = item => {
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteUsersAction(item) )
            }
        )
    }
    
    // Manejo de la edición
    const handleEdit = item => {
        dispatch( editUsersAction(item, handleOpen) );
    }

    // Manejo de la habilitación
    const handleEnable = item => {
        dispatch( enableUsersAction(item) );
    }
    
    // Manejo el reseteo
    const handleReset = item => {
        ConfirmMessage({
            title: 'Resetear Contraseña',
            text: 'No podrá revertir la operación. Se enviará mail al usuario',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#f6c23e',
            confirmButtonText: 'Si, Resetear'
        },
            () => {
                dispatch( resetPasswordUsersAction(item) )
            }
        )
    }

    // Inicializo las cabeceras
    const headers = [
        {   name: 'Legajo',
            width: null,
            style: 'text-center',
            field: 'legajo'
        },
        {   name: 'Apellido',
            width: null,
            style: 'text-center',
            field: 'apellido',
        },
        {   name: 'Nombre',
            width: null,
            style: 'text-center',
            field: 'nombre',
        },
        {   name: 'Nivel',
            width: null,
            style: 'text-center',
            field: 'nivel',
            subfield: 'descripcion'
        },
        {   name: 'Perfil',
            width: null,
            style: 'text-center',
            field: 'perfil',
            subfield: 'descripcion'
        },
        {   name: 'Unidad Judicial',
            width: null,
            style: 'text-center',
            field: 'unidad',
            subfield: 'descripcion'
        },
        {   name: 'Ofiju',
            width: null,
            style: 'text-center',
            field: 'ofiju',
            subfield: 'nombre'
        },
        {   name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {   name: ACTION_ENABLE,
                    handle: handleEnable,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, USUARIOS_CREAR)
                },
                {   name: ACTION_RESET_PASS,
                    handle: handleReset,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_MODIFICAR)
                },
                {   name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_MODIFICAR)
                },
                {   name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_ELIMINAR)
                }
            ]
        }
    ];

    // Cargo los datos
    useEffect(() => {
        dispatch( listUsersAction(params) );
    }, [search]);

    // Actualizo la página
    const handlePrev = () => {
        //Actualizo los parámetros
        const newParams = {
            ...params,
            paging: `${actualPage - 1},${pageSize}`,
        }
        //Hago la búsqueda
        dispatch( listUsersAction(newParams) );
    }

    const handleNext = () => {
        //Actualizo los parámetros
        const newParams = {
            ...params,
            paging: `${actualPage + 1},${pageSize}`,
        }
        //Hago la búsqueda
        dispatch( listUsersAction(newParams) );
    }



    // ==========================================================================================
    // RENDERIZO --------------------------------------------------------------------------------
    // ==========================================================================================

    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <UserSearch
                            setSearch={setSearch}
                        />                        
                        <hr/>
                        {   usersLoading 
                                ? 
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only">Cargando...</span>
                                    </Spinner>
                                : 
                                    null
                        }
                        {   users 
                                ? 
                                    <React.Fragment>
                                        <TableList
                                            prefix="am"
                                            headers={headers}
                                            items={users}
                                            state={{
                                                field: 'activo',
                                                disabledClass: 'table-danger',
                                                disabledValue: 0,
                                                hideActions: true
                                            }}
                                        />
                                        <div className="row">
                                            <div className="col-md-12">
                                                {   !isFirst 
                                                        ? 
                                                            <Button 
                                                                className="btn-circle mr-2" 
                                                                variant="primary" 
                                                                onClick={handlePrev}>
                                                                <ICON_PREV_ALT />
                                                            </Button>
                                                        : 
                                                            null
                                                }
                                                <Button variant="primary" disabled={true}>
                                                    { actualPage + 1 } de { totalPages }
                                                </Button>
                                                {   !isLast 
                                                        ? 
                                                            <Button 
                                                                className="btn-circle ml-2" 
                                                                variant="outline-primary" 
                                                                onClick={handleNext}>
                                                                <ICON_NEXT_ALT />
                                                            </Button>
                                                        : 
                                                            null
                                                }
                                            </div>
                                        </div>
                                    </React.Fragment>
                                : 
                                    null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserList;